"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _mixins = require("../mixins");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0;\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var mixins = (0, _utils.combineMixins)(_mixins.colorsMixin, _mixins.spaceMixin, _mixins.flexboxMixin, _mixins.sizeWithMinMaxMixin, _mixins.displayMixin);
var ViewBase = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(mixins.propTypes, {
    filterInvalidHTML: true,
    additionalPropsToFilter: ['overflow']
  })
})(_templateObject(), mixins, function (_ref) {
  var overflow = _ref.overflow;
  return !!overflow ? "overflow: ".concat(overflow, ";") : '';
});
var ViewBaseWithDocs = (0, _stencilReactDesc.describe)(ViewBase).description('The most basic layout element which other components are built on top of.');
ViewBaseWithDocs.propTypes = (0, _objectSpread2.default)({}, mixins.describedPropTypes, {
  children: _stencilReactDesc.PropTypes.node.description('Elements to display within the View.'),
  overflow: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'overflow' property on the element.")
});
var View = (0, _utils.withTestAttributes)({
  component: 'StencilReactView'
})(ViewBaseWithDocs);
View.displayName = 'View';
var _default = View;
exports.default = _default;